import { Inline } from '@sparkpost/matchbox';

/**
 * Matchbox Inline component
 * @see https://design.sparkpost.com/components/inline/
 */
export default Inline;
